import { AssetAbridged } from '../abridged/asset-abridged.model';
import { SiteAbridged } from '../abridged/site-abridged.model';
import { WorkflowItem } from './workflow-item.model';

export class AssetRestrictionWorkflowItem extends WorkflowItem {
  restrictions: string;
  site: SiteAbridged;
  asset: AssetAbridged;
  lockAsset: boolean;

  public deserialize(input: any): this {
    super.deserialize(input);

    this.restrictions = input.restrictions;
    this.details = input.restrictions;

    this.site = new SiteAbridged().deserialize(input.asset.site);
    this.asset = new AssetAbridged().deserialize(input.asset);
    this.lockAsset = input.lockAsset;

    return this;
  }

  public getTaskDetails(): string {
    return `Asset Restriction change needs approval on site: ${this.site.name}, asset: ${this.asset.name}`;
  }
};
